var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("sysconfig.BoxWrap.manage") } }, [
        _c(
          "div",
          { attrs: { slot: "header-right" }, slot: "header-right" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["LIST"] },
                    expression: "{pageName, list: ['LIST']}",
                  },
                ],
                attrs: {
                  size: "small",
                  type: "primary",
                  icon: "el-icon-search",
                },
                on: { click: _vm.searchData },
              },
              [_vm._v(_vm._s(_vm.$t("common.search")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: { pageName: _vm.pageName, list: ["ADD_EDIT"] },
                    expression: "{pageName, list: ['ADD_EDIT']}",
                  },
                ],
                attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.create },
              },
              [_vm._v(_vm._s(_vm.$t("common.create")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["LIST"] },
                expression: "{pageName, list: ['LIST']}",
              },
            ],
            staticClass: "action-container",
          },
          [
            _c(
              "el-form",
              { attrs: { size: "small", inline: "", "label-position": "top" } },
              [
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("sysconfig.input.configType"),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "sysconfig.input.configTypeHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "type", $$v)
                                },
                                expression: "searchVal.type",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("sysconfig.input.configCode"),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "sysconfig.input.configCodeHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.code,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "code", $$v)
                                },
                                expression: "searchVal.code",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-col", { attrs: { span: 7 } }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("sysconfig.BoxWrap.list") },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                stripe: "",
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
              on: { "cell-dblclick": _vm.celldblclick },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.tableIndex,
                  label: _vm.$t("sysconfig.table.systemConfigPk"),
                  width: "80",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "configType",
                  label: _vm.$t("sysconfig.table.configType"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "configCode",
                  label: _vm.$t("sysconfig.table.configCode"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "configVal",
                  label: _vm.$t("sysconfig.table.configVal"),
                  "min-width": "340",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sn",
                  label: _vm.$t("sysconfig.table.sequence"),
                  width: "80",
                  align: "center",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: _vm.$t("sysconfig.table.remark"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("sysconfig.table.action"),
                  fixed: "right",
                  width: "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-button", {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: {
                                pageName: _vm.pageName,
                                list: ["ADD_EDIT"],
                              },
                              expression: "{pageName, list: ['ADD_EDIT']}",
                            },
                          ],
                          staticClass: "t-square-btn t-green-btn",
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-edit",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.edit(scope.row)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("el-button", {
                          directives: [
                            {
                              name: "FPermission",
                              rawName: "v-FPermission",
                              value: {
                                pageName: _vm.pageName,
                                list: ["DELETE"],
                              },
                              expression: "{pageName, list: ['DELETE']}",
                            },
                          ],
                          staticClass: "t-square-btn t-red-btn",
                          attrs: {
                            type: "danger",
                            size: "mini",
                            icon: "el-icon-delete",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteItem(scope.row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Model",
        {
          attrs: {
            form: _vm.form,
            "init-form": _vm.initForm,
            "is-show": _vm.isShowModel,
            "dialog-status": _vm.dialogStatus,
            "save-item": _vm.saveItem,
          },
          on: {
            "update:isShow": function ($event) {
              _vm.isShowModel = $event
            },
            "update:is-show": function ($event) {
              _vm.isShowModel = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "configType",
                    label: _vm.$t("sysconfig.form.configType"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.configType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "configType", $$v)
                      },
                      expression: "form.configType",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "configCode",
                    label: _vm.$t("sysconfig.form.configCode"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.configCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "configCode", $$v)
                      },
                      expression: "form.configCode",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "configVal",
                    label: _vm.$t("sysconfig.form.configVal"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", autocomplete: "off" },
                    model: {
                      value: _vm.form.configVal,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "configVal", $$v)
                      },
                      expression: "form.configVal",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "sn",
                    label: _vm.$t("sysconfig.form.sn"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.sn,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sn", $$v)
                      },
                      expression: "form.sn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("sysconfig.form.remark"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", autocomplete: "off" },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }